import { Check, Grid2X2, ShieldCheck } from 'lucide-react';

export interface StepDefinition {
  id: number;
  title: string;
  shortTitle: string;
}

export const configuratorSteps: StepDefinition[] = [
  { id: 1, title: 'Vyberte produkt', shortTitle: 'Produkt' },
  { id: 2, title: 'Parametre výrobku', shortTitle: 'Parametre' },
  { id: 3, title: 'Dizajn potlače', shortTitle: 'Dizajn' },
  { id: 4, title: 'Kontrola návrhu', shortTitle: 'Kontrola' },
  { id: 5, title: 'Zhrnutie', shortTitle: 'Zhrnutie' },
];

export function AppHeader() {
  return (
    <header className="app-header">
      <button type="button" className="header-menu">
        <Grid2X2 size={18} /> MENU
      </button>
      <div className="brand" aria-label="LucasArt">
        LUCAS<span>ART</span>
      </div>
      <button type="button" className="header-exit">
        <span>×</span> Ukončiť
      </button>
    </header>
  );
}

export function StepSidebar({
  current,
  onStep,
  onBack,
  onNext,
  nextPending = false,
}: {
  current: number;
  onStep: (step: number) => void;
  onBack: () => void;
  onNext: () => void;
  nextPending?: boolean;
}) {
  const progress = Math.round((current / configuratorSteps.length) * 100);
  const heading = configuratorSteps[current - 1]?.title ?? 'Konfigurátor';
  const descriptions = [
    'Vyberte oblečenie, ktoré chcete navrhnúť.',
    'Nastavte variant, veľkosť, farbu a počet kusov.',
    'Vytvorte dizajn v profesionálnom 2D editore.',
    'Skontrolujte, či je návrh pripravený na výrobu.',
    'Skontrolujte konfiguráciu a priebežnú cenovú ponuku.',
  ];

  return (
    <aside className="step-sidebar">
      <div className="step-sidebar-scroll">
        <p className="eyebrow">Konfigurátor potlače</p>
        <h1>{heading}</h1>
        <p className="sidebar-intro">{descriptions[current - 1]}</p>
        <nav className="step-list" aria-label="Postup konfigurácie">
          {configuratorSteps.map(step => {
            const complete = step.id < current;
            return (
              <button
                key={step.id}
                type="button"
                className={`step-item ${step.id === current ? 'active' : ''} ${complete ? 'complete' : ''}`}
                onClick={() => onStep(step.id)}
              >
                <span className="step-number">
                  {complete ? <Check size={17} strokeWidth={3} /> : step.id}
                </span>
                <span>{step.title}</span>
              </button>
            );
          })}
        </nav>
      </div>
      <div className="sidebar-footer">
        <div className="progress-track">
          <span style={{ width: `${progress}%` }} />
        </div>
        <div className="progress-meta">
          <span>{progress}% hotovo</span>
          <span className="autosave-dot">Automaticky uložené</span>
        </div>
        <div className="sidebar-actions">
          {current > 1 && (
            <button type="button" className="back-button" onClick={onBack}>
              ‹ SPÄŤ
            </button>
          )}
          <button type="button" className="continue-button" onClick={onNext} disabled={nextPending}>
            {nextPending
              ? 'UKLADÁM…'
              : current === 5
                ? 'POTVRDIŤ KONFIGURÁCIU'
                : current === 4
                  ? 'NA ZHRNUTIE'
                  : 'POKRAČOVAŤ'}
          </button>
        </div>
        <div className="secure-note">
          <ShieldCheck size={16} /> Vaše návrhy sú zabezpečené
        </div>
      </div>
    </aside>
  );
}
